import {ITimerContext, OnTimerFn} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {SlotId} from '@mintdata/mint-kit/api/models/Identifiers';
import Timer = NodeJS.Timer;

export class TimerContextImpl implements ITimerContext {
    private static instance: ITimerContext = new TimerContextImpl();
    private timers: Map<SlotId, Timer> = new Map<SlotId, Timer>();

    private constructor() {

    }

    public static getInstance(): ITimerContext {
        return this.instance;
    }

    registerOneTime(intervalMs: number, timerFn: OnTimerFn): void
    {
        setTimeout(timerFn, intervalMs);
    }

    registerRepeating(intervalMs: number, timerFn: OnTimerFn, slotId: SlotId): void
    {
        if (this.timers.has(slotId)) {
           const interval = this.timers.get(slotId);
           clearInterval(interval);
           this.timers.set(slotId, setInterval(timerFn, intervalMs));
        } else
        {
            const interval = setInterval(timerFn, intervalMs);
            this.timers.set(slotId, interval);
        }
    }

    stopTimerForSlot(slotId:SlotId):void
    {
        const interval = this.timers.get(slotId);
        if (undefined != interval)
        {
            clearInterval(interval);
        }
    }
}
